import React from 'react';
import './Skeleton.css';

export default function PodcastTranscriptSkeleton() {
    return (
        <div className="w-full space-y-6 py-4 skeleton-fade-in" aria-busy="true" aria-label="Loading transcript content">
            {/* Transcript Controls Bar */}
            <div className="flex items-center justify-between pb-3 border-b border-slider">
                <div className="h-8 w-44 rounded-full shimmer-pulse" />
                <div className="flex items-center gap-2">
                    <div className="h-8 w-24 rounded-full shimmer-pulse" />
                    <div className="h-8 w-8 rounded-full shimmer-pulse" />
                </div>
            </div>

            {/* Timeline Group 1 */}
            <div className="space-y-3">
                <div className="flex items-center gap-2">
                    <div className="h-5 w-16 rounded-full shimmer-pulse bg-primary-cyan/20" />
                    <div className="h-5 w-36 rounded-md shimmer-pulse" />
                </div>
                {/* Words Block simulating word-by-word timestamp tokens */}
                <div className="flex flex-wrap gap-2 p-3 rounded-xl bg-hover border border-slider/50">
                    <div className="h-4 w-12 rounded shimmer-pulse" />
                    <div className="h-4 w-20 rounded shimmer-pulse" />
                    <div className="h-4 w-16 rounded shimmer-pulse" />
                    <div className="h-4 w-10 rounded shimmer-pulse" />
                    <div className="h-4 w-24 rounded shimmer-pulse" />
                    <div className="h-4 w-14 rounded shimmer-pulse" />
                    <div className="h-4 w-18 rounded shimmer-pulse" />
                    <div className="h-4 w-12 rounded shimmer-pulse" />
                    <div className="h-4 w-28 rounded shimmer-pulse" />
                    <div className="h-4 w-16 rounded shimmer-pulse" />
                    <div className="h-4 w-8 rounded shimmer-pulse" />
                    <div className="h-4 w-20 rounded shimmer-pulse" />
                    <div className="h-4 w-14 rounded shimmer-pulse" />
                    <div className="h-4 w-22 rounded shimmer-pulse" />
                    <div className="h-4 w-10 rounded shimmer-pulse" />
                </div>
            </div>

            {/* Timeline Group 2 */}
            <div className="space-y-3 pt-2">
                <div className="flex items-center gap-2">
                    <div className="h-5 w-16 rounded-full shimmer-pulse bg-primary-cyan/20" />
                    <div className="h-5 w-44 rounded-md shimmer-pulse" />
                </div>
                <div className="flex flex-wrap gap-2 p-3 rounded-xl bg-hover border border-slider/50">
                    <div className="h-4 w-16 rounded shimmer-pulse" />
                    <div className="h-4 w-12 rounded shimmer-pulse" />
                    <div className="h-4 w-24 rounded shimmer-pulse" />
                    <div className="h-4 w-14 rounded shimmer-pulse" />
                    <div className="h-4 w-8 rounded shimmer-pulse" />
                    <div className="h-4 w-20 rounded shimmer-pulse" />
                    <div className="h-4 w-18 rounded shimmer-pulse" />
                    <div className="h-4 w-12 rounded shimmer-pulse" />
                    <div className="h-4 w-16 rounded shimmer-pulse" />
                    <div className="h-4 w-26 rounded shimmer-pulse" />
                    <div className="h-4 w-10 rounded shimmer-pulse" />
                    <div className="h-4 w-14 rounded shimmer-pulse" />
                    <div className="h-4 w-20 rounded shimmer-pulse" />
                    <div className="h-4 w-12 rounded shimmer-pulse" />
                </div>
            </div>

            {/* Timeline Group 3 */}
            <div className="space-y-3 pt-2">
                <div className="flex items-center gap-2">
                    <div className="h-5 w-16 rounded-full shimmer-pulse bg-primary-cyan/20" />
                    <div className="h-5 w-32 rounded-md shimmer-pulse" />
                </div>
                <div className="flex flex-wrap gap-2 p-3 rounded-xl bg-hover border border-slider/50">
                    <div className="h-4 w-14 rounded shimmer-pulse" />
                    <div className="h-4 w-20 rounded shimmer-pulse" />
                    <div className="h-4 w-12 rounded shimmer-pulse" />
                    <div className="h-4 w-16 rounded shimmer-pulse" />
                    <div className="h-4 w-24 rounded shimmer-pulse" />
                    <div className="h-4 w-10 rounded shimmer-pulse" />
                    <div className="h-4 w-18 rounded shimmer-pulse" />
                    <div className="h-4 w-14 rounded shimmer-pulse" />
                </div>
            </div>
        </div>
    );
}
